import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const formatProBono = ({
	pb_activity: activity,
	pb_time_period: timePeriod,
}) => {
	let proBono = activity;

	if (timePeriod) {
		proBono += `, ${timePeriod}`;
	}

	return proBono;
};

const ProBonos = (props) => {
	const proBonos = props.data.pro_bonos;

	if (!_.isArray(proBonos) || _.isEmpty(proBonos)) {
		return null;
	}

	return (
		<ul className="bio-list">
			{_.map(proBonos, proBono => (
				<li className="bio-list__item" key={_.uniqueId('list-item-')}>
					{formatProBono(proBono)}
				</li>
			))}
		</ul>
	);
};

ProBonos.propTypes = {
	data: PropTypes.object.isRequired,
};

export default ProBonos;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/pro-bonos.js